import axiosInstance from "./axiosInstance";
import Cookies from "js-cookie";

function toServiceError(error) {
  const message =
    (typeof error?.response?.data?.message === "string" &&
      error.response.data.message) ||
    (typeof error?.message === "string" && error.message) ||
    "Request failed";
  const err = new Error(message);
  err.status = error?.response?.status;
  err.data = error?.response?.data;
  return err;
}

const blogService = {
  getAllBlogs: async (page = 1, limit = 15) => {
    try {
      const response = await axiosInstance.get(
        `/blogs/all-blogs?page=${page}&limit=${limit}`,
        {
          // Public endpoint: do not attach Authorization header
          headers: { "X-Skip-Auth": true },
          skipAuth: true,
        }
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  getBlogById: async (id) => {
    try {
      const response = await axiosInstance.get(`/blogs/${id}`);
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  createBlog: async (payload) => {
    try {
      const formData = new FormData();
      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.post(
        `/blogs/create`,
        formData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  updateBlog: async (id, payload) => {
    try {
      const formData = new FormData();
      Object.entries(payload || {}).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          formData.append(key, value);
        }
      });
      console.log(formData, "formData");

      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.put(
        `/blogs/${id}`,
        formData,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
  deleteBlog: async (id) => {
    try {
      const token =
        Cookies.get("token") ||
        (typeof window !== "undefined"
          ? localStorage.getItem("token")
          : undefined);
      const response = await axiosInstance.delete(
        `/blogs/${id}`,
        token ? { headers: { Authorization: `Bearer ${token}` } } : undefined
      );
      return response.data;
    } catch (error) {
      throw toServiceError(error);
    }
  },
};

export default blogService;
